import React from 'react'
import { StepProps } from '../../Step'
import { Button } from '@mui/material'
import { navigateToStepIndex } from 'components/Stepper/helpers/stepper.helpers'
import { exists, onlyPopulatedValues } from 'app/util'

type Props = {
  stepProps: StepProps[]
  setCurrentStepIndex: React.Dispatch<React.SetStateAction<number>>
  currentStepIndex: number
  submitButtonText?: string
  hideSubmit?: boolean
}
export const StepperFooter = ({ stepProps, ...props }: Props) => {
  const onLastStep = props.currentStepIndex === stepProps.length - 1
  const onFirstStep = props.currentStepIndex === 0
  const selectedStep = stepProps[props.currentStepIndex]
  const errors = onlyPopulatedValues(selectedStep?.errors || [])
  // An error is something that went wrong; a disabled reason is just work still
  // to do, so it stays neutral rather than scolding. Errors win when both exist.
  const blockedReason = !exists(errors) && selectedStep?.disabled ? selectedStep.disabledReason : ''

  return (
    <footer className="relative flex-grow-0 transition-all flex-none w-full bg-white border-t border-mm-neutral-1-200">
      {/* Above the buttons rather than between them: in the same row a long
          message pushed Previous and Next apart by however much it happened to say. */}
      {exists(errors) && (
        <p className="w-full px-4 pt-2 text-sm font-semibold text-mm-warning-600">
          {errors.join(', ')}
        </p>
      )}

      {blockedReason && (
        <p className="w-full px-4 pt-2 text-sm text-mm-neutral-1-600">{blockedReason}</p>
      )}

      <div className="flex justify-between items-center w-full px-4 py-2">
        {onFirstStep ? (
          <div />
        ) : (
          <Button
            color="primary"
            variant="outlined"
            onClick={() => {
              props.setCurrentStepIndex(
                navigateToStepIndex(props.currentStepIndex - 1, props.currentStepIndex, stepProps)
              )
            }}
          >
            Previous
          </Button>
        )}

        {/* Render next/submit button if not intentionally hidden */}
        {!(props.hideSubmit && onLastStep) && (
          <Button
            color="primary"
            variant="contained"
            disabled={selectedStep?.disabled}
            onClick={() => {
              // If the 'onNext' prop was given, run that function
              // NOTE:  This is how the 'complete' is meant to be used.
              selectedStep?.onNext && selectedStep.onNext()

              // If On the Last Step, Don't do anything
              if (onLastStep) return

              if (selectedStep)
                props.setCurrentStepIndex(
                  navigateToStepIndex(props.currentStepIndex + 1, props.currentStepIndex, stepProps)
                )
            }}
          >
            {onLastStep ? props.submitButtonText || 'Publish' : 'Next'}
          </Button>
        )}
      </div>
    </footer>
  )
}
